import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import i18n from '../../i18n'
import { I18nextProvider } from 'react-i18next'
import routes from './maintenanceRoutes'
import PropTypes from 'prop-types'

export default class MaintenanceRoot extends Component {
  constructor () {
    super()
    this.views = {}
  }

  loadView (fileName) {
    if (this.views[fileName]) {
      return this.views[fileName]
    }

    new Promise(resolve => {
      require.ensure(['../maintenance/maintenanceRoute.js'], require => {
        this.forceUpdate()
        resolve(require('../maintenance/maintenanceRoute').default)
      })
    })
    .then(View => {
      const { customMessage } = this.props
      this.views[fileName] = <View customMessage={customMessage} />
    })
    .then(() => this.forceUpdate())
    .catch(err => {
      console.error(err)
      throw new Error(err)
    })
    return <div />
  }
  render () {
    return (
      <I18nextProvider i18n={i18n}>
        <Route
          path={routes.maintenance}
          exact
          component={() => this.loadView(routes.maintenance)}
        />
      </I18nextProvider>
    )
  }
}
MaintenanceRoot.propTypes = {
  customMessage: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/routes/maintenance/maintenanceRootRoute.js